/**
 * Texto visível a partir de HTML (validação, placeholders).
 * Funciona no browser; fora dele usa fallback simples por regex.
 */
export function htmlToPlainText(html: string): string {
  const raw = (html ?? '').trim();
  if (!raw) return '';
  if (typeof document !== 'undefined') {
    const d = document.createElement('div');
    d.innerHTML = raw;
    return (d.textContent || '').replace(/\u00a0/g, ' ').trim();
  }
  return raw
    .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')
    .replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, '')
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

const BAD_TAGS = ['SCRIPT', 'IFRAME', 'OBJECT', 'EMBED', 'LINK', 'STYLE', 'META', 'BASE', 'FORM'];

/** Sanitização leve para exibir HTML do admin no app cliente (apenas browser). */
export function sanitizeRichHtml(html: string): string {
  const raw = (html ?? '').trim();
  if (!raw) return '';
  if (typeof document === 'undefined') return '';
  const tpl = document.createElement('template');
  tpl.innerHTML = raw;
  for (const tag of BAD_TAGS) {
    tpl.content.querySelectorAll(tag.toLowerCase()).forEach((n) => n.remove());
  }
  tpl.content.querySelectorAll('*').forEach((el) => {
    [...el.attributes].forEach((a) => {
      const n = a.name.toLowerCase();
      if (n.startsWith('on')) el.removeAttribute(a.name);
      else if (n === 'href' && /^\s*javascript:/i.test(a.value)) el.removeAttribute('href');
    });
  });
  return tpl.innerHTML;
}
